var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((Object.entries(_vm.query)),function(ref){
var field = ref[0];
var value = ref[1];
return _c('j-query-chip',{key:field,staticClass:"ma-1",attrs:{"field":field,"value":value,"small":""}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }